import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hoosierlifeinsurance.com';

const CATEGORIES = ['All', 'Term Life', 'Whole Life', 'Final Expense', 'Annuities', 'Mortgage Protection', 'Wealth Building', 'Special Cases', 'Universal Life', 'Family Coverage'];

const ARTICLES = [
  {
    slug: 'term-life-insurance-indianapolis',
    title: 'Term Life Insurance Indianapolis: Complete 2025 Guide',
    excerpt: 'Everything Indianapolis families need to know about term life insurance in 2025: costs, coverage amounts, top carriers, and how to get the best rates.',
    category: 'Term Life',
    readTime: '12 min read',
    date: 'January 15, 2025',
    icon: 'ri-time-line',
    image: 'https://public.readdy.ai/ai/img_res/74f7e694975966d80e72b83168e1f620.jpg',
  },
  {
    slug: 'whole-life-insurance-indianapolis',
    title: 'Whole Life Insurance Indianapolis: Permanent Coverage Guide 2025',
    excerpt: 'Complete guide to whole life insurance in Indianapolis. Learn about permanent coverage, cash value growth, costs, and whether whole life is right for your family.',
    category: 'Whole Life',
    readTime: '10 min read',
    date: 'January 15, 2025',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=mature%20couple%20smiling%20reviewing%20financial%20documents%20at%20home%20desk%20warm%20lighting%20clean%20minimal%20background%20Indianapolis%20Indiana&width=600&height=400&seq=blog002&orientation=landscape',
  },
  {
    slug: 'universal-life-insurance-indianapolis',
    title: 'Universal Life Insurance Indianapolis: Flexible Coverage Explained',
    excerpt: 'Discover how universal life insurance works in Indianapolis — flexible premiums, adjustable death benefits, and cash value growth for Indiana families.',
    category: 'Universal Life',
    readTime: '9 min read',
    date: 'January 16, 2025',
    icon: 'ri-settings-3-line',
    image: 'https://readdy.ai/api/search-image?query=financial%20advisor%20explaining%20insurance%20policy%20to%20couple%20in%20modern%20office%20clean%20white%20background%20professional%20setting%20Indianapolis&width=600&height=400&seq=blog003&orientation=landscape',
  },
  {
    slug: 'indexed-universal-life-indianapolis',
    title: 'Indexed Universal Life Insurance Indianapolis: IUL Guide 2025',
    excerpt: 'How IUL policies work in Indianapolis — market-linked growth with downside protection, tax-free loans, and retirement income strategies.',
    category: 'Universal Life',
    readTime: '11 min read',
    date: 'January 17, 2025',
    icon: 'ri-line-chart-line',
    image: 'https://readdy.ai/api/search-image?query=stock%20market%20growth%20chart%20on%20screen%20with%20insurance%20documents%20on%20desk%20clean%20minimal%20office%20background%20warm%20tones&width=600&height=400&seq=blog004&orientation=landscape',
  },
  {
    slug: 'final-expense-insurance-indianapolis',
    title: 'Final Expense Insurance Indianapolis: Costs & Coverage 2025',
    excerpt: 'Everything Indianapolis seniors need to know about final expense insurance — costs, coverage amounts, top carriers, and how to qualify.',
    category: 'Final Expense',
    readTime: '8 min read',
    date: 'January 18, 2025',
    icon: 'ri-shield-line',
    image: 'https://readdy.ai/api/search-image?query=senior%20couple%20sitting%20together%20reviewing%20insurance%20paperwork%20at%20kitchen%20table%20warm%20cozy%20home%20Indianapolis%20Indiana%20soft%20natural%20light&width=600&height=400&seq=blog005&orientation=landscape',
  },
  {
    slug: 'annuities-retirement-indianapolis',
    title: 'Annuities & Retirement Planning Indianapolis: 2025 Guide',
    excerpt: 'How annuities work in Indianapolis — fixed, variable, and indexed annuities for guaranteed retirement income and tax-deferred growth.',
    category: 'Annuities',
    readTime: '10 min read',
    date: 'January 19, 2025',
    icon: 'ri-funds-line',
    image: 'https://readdy.ai/api/search-image?query=retired%20couple%20enjoying%20outdoor%20patio%20with%20financial%20planning%20documents%20on%20table%20sunny%20day%20Indianapolis%20Indiana%20clean%20background&width=600&height=400&seq=blog006&orientation=landscape',
  },
  {
    slug: 'mortgage-protection-indianapolis',
    title: 'Mortgage Protection Insurance Indianapolis: Keep Your Home Safe',
    excerpt: 'How mortgage protection insurance works in Indianapolis — costs, coverage, and how to protect your family\'s home if something happens to you.',
    category: 'Mortgage Protection',
    readTime: '9 min read',
    date: 'January 20, 2025',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=family%20standing%20in%20front%20of%20beautiful%20suburban%20home%20Indianapolis%20Indiana%20sunny%20day%20green%20lawn%20clean%20white%20background&width=600&height=400&seq=blog007&orientation=landscape',
  },
  {
    slug: 'best-life-insurance-indianapolis',
    title: 'Best Life Insurance Companies Indianapolis: 2025 Rankings',
    excerpt: 'Top-rated life insurance carriers in Indianapolis ranked by price, financial strength, and customer service — find the best policy for your family.',
    category: 'Term Life',
    readTime: '13 min read',
    date: 'January 21, 2025',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=insurance%20agent%20shaking%20hands%20with%20happy%20client%20in%20bright%20modern%20office%20Indianapolis%20Indiana%20professional%20clean%20background&width=600&height=400&seq=blog008&orientation=landscape',
  },
  {
    slug: 'life-insurance-diabetes-indianapolis',
    title: 'Life Insurance with Diabetes Indianapolis: Get Approved in 2025',
    excerpt: 'How to get affordable life insurance in Indianapolis with Type 1 or Type 2 diabetes — which carriers are most lenient and what rates to expect.',
    category: 'Special Cases',
    readTime: '10 min read',
    date: 'January 22, 2025',
    icon: 'ri-heart-add-line',
    image: 'https://readdy.ai/api/search-image?query=person%20with%20diabetes%20reviewing%20insurance%20documents%20at%20home%20desk%20clean%20minimal%20background%20warm%20lighting%20Indianapolis&width=600&height=400&seq=blog009&orientation=landscape',
  },
  {
    slug: 'life-insurance-rates-indianapolis',
    title: 'Life Insurance Rates Indianapolis: 2025 Price Comparison',
    excerpt: 'Current life insurance rates in Indianapolis by age, health, and coverage amount — see exactly what you\'ll pay and how to get the lowest rates.',
    category: 'Term Life',
    readTime: '11 min read',
    date: 'January 23, 2025',
    icon: 'ri-price-tag-3-line',
    image: 'https://readdy.ai/api/search-image?query=calculator%20and%20insurance%20rate%20comparison%20chart%20on%20clean%20white%20desk%20minimal%20professional%20background%20Indianapolis&width=600&height=400&seq=blog010&orientation=landscape',
  },
  {
    slug: 'life-insurance-seniors-over-60-indianapolis',
    title: 'Life Insurance for Seniors Over 60 Indianapolis: Best Options',
    excerpt: 'Best life insurance options for Indianapolis seniors over 60 — term, whole life, and final expense policies with no medical exam options.',
    category: 'Final Expense',
    readTime: '9 min read',
    date: 'January 24, 2025',
    icon: 'ri-user-heart-line',
    image: 'https://readdy.ai/api/search-image?query=active%20senior%20couple%20over%2060%20smiling%20outdoors%20Indianapolis%20Indiana%20park%20sunny%20day%20clean%20background%20healthy%20lifestyle&width=600&height=400&seq=blog011&orientation=landscape',
  },
  {
    slug: 'life-insurance-new-parents-indianapolis',
    title: 'Life Insurance for New Parents Indianapolis: Protect Your Baby',
    excerpt: 'Why new parents in Indianapolis need life insurance immediately — how much coverage you need, best policy types, and how to apply quickly.',
    category: 'Term Life',
    readTime: '8 min read',
    date: 'January 25, 2025',
    icon: 'ri-parent-line',
    image: 'https://readdy.ai/api/search-image?query=young%20parents%20holding%20newborn%20baby%20in%20bright%20cozy%20nursery%20Indianapolis%20Indiana%20warm%20soft%20lighting%20clean%20minimal%20background&width=600&height=400&seq=blog012&orientation=landscape',
  },
  {
    slug: 'term-vs-whole-life-indianapolis',
    title: 'Term vs Whole Life Insurance Indianapolis: Which Is Right for You?',
    excerpt: 'Side-by-side comparison of term and whole life insurance for Indianapolis families — costs, benefits, and which policy fits your situation.',
    category: 'Whole Life',
    readTime: '12 min read',
    date: 'January 26, 2025',
    icon: 'ri-scales-3-line',
    image: 'https://readdy.ai/api/search-image?query=two%20insurance%20policy%20documents%20side%20by%20side%20on%20clean%20white%20desk%20comparison%20concept%20minimal%20professional%20background&width=600&height=400&seq=blog013&orientation=landscape',
  },
  {
    slug: 'business-key-person-insurance-indianapolis',
    title: 'Key Person Life Insurance Indianapolis: Protect Your Business',
    excerpt: 'How key person life insurance protects Indianapolis businesses — costs, coverage amounts, and how to structure a policy for your company.',
    category: 'Special Cases',
    readTime: '10 min read',
    date: 'January 27, 2025',
    icon: 'ri-briefcase-line',
    image: 'https://readdy.ai/api/search-image?query=business%20owner%20in%20modern%20Indianapolis%20office%20reviewing%20key%20person%20insurance%20documents%20professional%20clean%20background%20warm%20lighting&width=600&height=400&seq=blog014&orientation=landscape',
  },
  {
    slug: 'life-insurance-high-blood-pressure',
    title: 'Life Insurance with High Blood Pressure Indianapolis: 2025 Guide',
    excerpt: 'How to get approved for life insurance in Indianapolis with high blood pressure — which carriers are most lenient and what rates to expect.',
    category: 'Special Cases',
    readTime: '9 min read',
    date: 'January 28, 2025',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=person%20checking%20blood%20pressure%20at%20home%20with%20insurance%20documents%20nearby%20clean%20minimal%20background%20warm%20lighting%20Indianapolis&width=600&height=400&seq=blog015&orientation=landscape',
  },
  {
    slug: 'life-insurance-private-pilots',
    title: 'Life Insurance for Private Pilots Indianapolis: Get Covered in 2025',
    excerpt: 'How private pilots in Indianapolis can get affordable life insurance — which carriers cover aviation risk and what premiums to expect.',
    category: 'Special Cases',
    readTime: '8 min read',
    date: 'January 29, 2025',
    icon: 'ri-flight-takeoff-line',
    image: 'https://readdy.ai/api/search-image?query=private%20pilot%20standing%20next%20to%20small%20aircraft%20at%20Indianapolis%20airport%20sunny%20day%20clean%20background%20professional%20confident&width=600&height=400&seq=blog016&orientation=landscape',
  },
  {
    slug: 'wealth-building-life-insurance-indianapolis',
    title: 'Wealth Building with Life Insurance Indianapolis: Tax-Free Strategies',
    excerpt: 'How Indianapolis families use permanent life insurance for tax-free wealth building, retirement income, and generational wealth transfer.',
    category: 'Wealth Building',
    readTime: '11 min read',
    date: 'January 30, 2025',
    icon: 'ri-money-dollar-circle-line',
    image: 'https://readdy.ai/api/search-image?query=financial%20growth%20concept%20with%20coins%20and%20documents%20on%20clean%20white%20desk%20Indianapolis%20Indiana%20wealth%20building%20minimal%20professional&width=600&height=400&seq=blog017&orientation=landscape',
  },
  {
    slug: 'how-much-life-insurance-indiana',
    title: 'How Much Life Insurance Do I Need in Indiana? 2025 Calculator',
    excerpt: 'The honest, numbers-first answer for Hoosier families — with a step-by-step DIME calculator, Indiana-specific mortgage and college cost data, and real 2025 sample rates.',
    category: 'Term Life',
    readTime: '10 min read',
    date: 'February 10, 2025',
    icon: 'ri-calculator-line',
    image: 'https://readdy.ai/api/search-image?query=Indiana%20family%20at%20kitchen%20table%20reviewing%20life%20insurance%20calculator%20worksheet%20warm%20home%20lighting%20natural%20daylight%20clean%20white%20background%20professional%20couple&width=600&height=400&seq=blog018&orientation=landscape',
  },
  {
    slug: 'cheapest-life-insurance-indiana',
    title: 'Cheapest Life Insurance in Indiana: How Hoosiers Save in 2025',
    excerpt: 'Find the lowest-cost life insurance in Indiana for 2025. Real rates from top carriers, 6 proven money-saving strategies, and the cheapest policies for Hoosier families.',
    category: 'Term Life',
    readTime: '9 min read',
    date: 'February 14, 2025',
    icon: 'ri-price-tag-3-line',
    image: 'https://readdy.ai/api/search-image?query=smiling%20Indiana%20couple%20reviewing%20affordable%20life%20insurance%20rates%20on%20laptop%20at%20bright%20modern%20home%20desk%20savings%20piggy%20bank%20on%20table%20clean%20white%20minimal%20background&width=600&height=400&seq=blog019&orientation=landscape',
  },
  {
    slug: 'life-insurance-for-families-indianapolis',
    title: 'Best Life Insurance for Indianapolis Families: Coverage & Costs 2025',
    excerpt: 'Complete guide to life insurance for Indianapolis families — coverage amounts, best policy types, top carriers, and real 2025 pricing for every family stage in Central Indiana.',
    category: 'Term Life',
    readTime: '11 min read',
    date: 'February 18, 2025',
    icon: 'ri-group-line',
    image: 'https://readdy.ai/api/search-image?query=happy%20Indianapolis%20family%20of%20four%20at%20home%20parents%20and%20two%20young%20children%20smiling%20bright%20living%20room%20clean%20modern%20warm%20natural%20light%20insurance%20planning%20documents&width=600&height=400&seq=blog020&orientation=landscape',
  },
  {
    slug: 'life-insurance-quotes-indiana',
    title: 'Life Insurance Quotes Indiana: Get Accurate Rates in Minutes (2025)',
    excerpt: 'What determines your Indiana life insurance quote, real sample pricing by age and health class, and how to compare quotes from 10+ carriers side-by-side for the lowest rate.',
    category: 'Term Life',
    readTime: '10 min read',
    date: 'February 22, 2025',
    icon: 'ri-search-2-line',
    image: 'https://readdy.ai/api/search-image?query=Indiana%20insurance%20agent%20comparing%20life%20insurance%20quotes%20on%20computer%20screen%20bright%20professional%20office%20Indianapolis%20clean%20minimal%20background%20showing%20rate%20comparison%20charts&width=600&height=400&seq=blog021&orientation=landscape',
  },
  {
    slug: 'life-insurance-indiana-seniors',
    title: 'Life Insurance for Seniors in Indiana: Best Options & Rates (2025)',
    excerpt: 'Best life insurance for Indiana seniors aged 60–85 — final expense, guaranteed issue, and term life compared with real 2025 rates. No exam options available statewide.',
    category: 'Final Expense',
    readTime: '11 min read',
    date: 'March 1, 2025',
    icon: 'ri-user-heart-line',
    image: 'https://readdy.ai/api/search-image?query=active%20senior%20couple%20in%20their%2060s%20smiling%20outdoors%20Indiana%20park%20autumn%20leaves%20golden%20hour%20warm%20light%20healthy%20retired%20lifestyle%20cheerful%20clean%20blurred%20background%20photorealistic&width=600&height=400&seq=blog022&orientation=landscape',
  },
  {
    slug: 'no-medical-exam-life-insurance-indiana',
    title: 'No Medical Exam Life Insurance Indiana: Get Covered Today (2025)',
    excerpt: 'No blood tests, no doctor visits, no waiting weeks for results. Compare simplified issue and guaranteed issue options in Indiana — same-day approval available for most applicants.',
    category: 'Term Life',
    readTime: '11 min read',
    date: 'March 10, 2025',
    icon: 'ri-checkbox-circle-line',
    image: 'https://readdy.ai/api/search-image?query=relaxed%20Indiana%20man%20completing%20life%20insurance%20application%20on%20laptop%20at%20bright%20home%20office%20clean%20white%20minimal%20background%20no%20stress%20easy%20approval%20instant%20coverage%20warm%20natural%20light&width=600&height=400&seq=blog023&orientation=landscape',
  },
  {
    slug: 'life-insurance-self-employed-indiana',
    title: 'Life Insurance for Self-Employed Indiana: Coverage, Costs & Tax Guide (2025)',
    excerpt: 'Why Indiana freelancers, contractors, and small business owners need more life insurance than W-2 employees — and the best policy types, real 2025 rates, and tax strategy.',
    category: 'Special Cases',
    readTime: '12 min read',
    date: 'March 15, 2025',
    icon: 'ri-briefcase-3-line',
    image: 'https://readdy.ai/api/search-image?query=self%20employed%20Indiana%20small%20business%20owner%20entrepreneur%20reviewing%20life%20insurance%20documents%20at%20modern%20home%20office%20desk%20with%20laptop%20coffee%20cup%20clean%20bright%20minimal%20background%20Indianapolis%20professional%20focused&width=600&height=400&seq=blog024&orientation=landscape',
  },
  {
    slug: 'burial-insurance-indiana',
    title: 'Burial Insurance Indiana: Costs, Coverage & Best Plans (2025)',
    excerpt: 'The average Indiana funeral costs $9,500–$11,650. Compare burial insurance plans for Hoosier seniors — real rates by age, top carriers, guaranteed approval options, and 5 mistakes to avoid.',
    category: 'Final Expense',
    readTime: '10 min read',
    date: 'March 18, 2025',
    icon: 'ri-shield-line',
    image: 'https://readdy.ai/api/search-image?query=dignified%20senior%20Indiana%20couple%20in%20their%2070s%20sitting%20together%20at%20home%20reviewing%20final%20expense%20burial%20insurance%20documents%20peaceful%20warm%20living%20room%20clean%20natural%20light%20soft%20bokeh%20compassionate%20planning&width=600&height=400&seq=blog025&orientation=landscape',
  },
  {
    slug: 'life-insurance-smokers-indiana',
    title: 'Life Insurance for Smokers in Indiana: Real 2025 Rates & Best Carriers',
    excerpt: 'Smokers in Indiana pay 2–4× the non-smoker rate — but carrier rates vary 30–50% for the same profile. Compare tobacco rates by age, find the most lenient carriers, and learn when you qualify for non-smoker pricing.',
    category: 'Special Cases',
    readTime: '10 min read',
    date: 'March 20, 2025',
    icon: 'ri-user-line',
    image: 'https://readdy.ai/api/search-image?query=determined%20Indiana%20adult%20researching%20life%20insurance%20options%20on%20laptop%20at%20home%20bright%20clean%20modern%20desk%20focused%20person%20seeking%20affordable%20coverage%20tobacco%20history%20warm%20light%20professional%20setting&width=600&height=400&seq=blog026&orientation=landscape',
  },
  {
    slug: 'life-insurance-stay-at-home-parents-indiana',
    title: 'Life Insurance for Stay-at-Home Parents Indiana: The $184K Coverage Guide (2025)',
    excerpt: 'Indiana stay-at-home parents provide $92,000+ in annual household services — yet most carry zero coverage. Learn how to calculate your true replacement value, why $750K in term costs under $30/month, and the 5 costly SAHP mistakes to avoid.',
    category: 'Family Coverage',
    readTime: '12 min read',
    date: 'March 22, 2025',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=stay%20at%20home%20parent%20Indiana%20mom%20playing%20with%20two%20young%20children%20in%20bright%20sunny%20living%20room%20warm%20natural%20light%20cozy%20family%20home%20clean%20minimal%20background%20loving%20nurturing%20family%20scene&width=600&height=400&seq=blog027&orientation=landscape',
  },
  {
    slug: 'life-insurance-checklist-indiana',
    title: 'Indiana Life Insurance Checklist: Top 10 Steps Before You Buy',
    excerpt: 'The 10 most critical steps every Indiana family must complete before buying life insurance — from calculating your coverage gap to naming beneficiaries. Includes links to the full 35-step interactive checklist.',
    category: 'Term Life',
    readTime: '8 min read',
    date: 'April 12, 2025',
    icon: 'ri-checkbox-multiple-line',
    image: 'https://readdy.ai/api/search-image?query=Indiana%20family%20sitting%20at%20kitchen%20table%20reviewing%20life%20insurance%20checklist%20documents%20with%20pen%20and%20coffee%20warm%20natural%20light%20organized%20planning%20session%20lifestyle%20photography%20clean%20bright%20home%20interior&width=600&height=400&seq=blog028&orientation=landscape',
  },
];

const CATEGORY_COLORS: Record<string, string> = {
  'Term Life': 'bg-[#D97642]/10 text-[#D97642]',
  'Whole Life': 'bg-[#1A3A52]/10 text-[#1A3A52]',
  'Final Expense': 'bg-amber-100 text-amber-700',
  'Annuities': 'bg-emerald-100 text-emerald-700',
  'Mortgage Protection': 'bg-rose-100 text-rose-700',
  'Wealth Building': 'bg-yellow-100 text-yellow-700',
  'Special Cases': 'bg-slate-100 text-slate-600',
  'Universal Life': 'bg-[#1A3A52]/10 text-[#1A3A52]',
  'Family Coverage': 'bg-emerald-100 text-emerald-700',
};

export default function BlogIndexPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Life Insurance Blog Indianapolis | Hoosier Life Insurance';

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '30+ expert life insurance guides for Indianapolis families — reviewed and updated 2026. Term life, whole life, final expense, annuities, and wealth-building strategies explained by licensed Indiana agents.');
    setMeta('keywords', 'life insurance blog Indianapolis, Indiana life insurance guides, term life insurance articles, Indianapolis insurance tips');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${SITE_URL}/blog`);

    // Inject Schema.org JSON-LD
    const schemas = [
      // WebPage Schema
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Life Insurance Blog Indianapolis | Hoosier Life Insurance',
        description: 'Expert life insurance guides for Indianapolis families. Browse 27 in-depth articles on term life, whole life, annuities, final expense, and wealth-building strategies in Indiana.',
        url: `${SITE_URL}/blog`,
        inLanguage: 'en-US',
        isPartOf: {
          '@type': 'WebSite',
          name: 'Hoosier Life Insurance',
          url: SITE_URL,
        },
      },
      // BreadcrumbList Schema
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: SITE_URL,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Blog',
            item: `${SITE_URL}/blog`,
          },
        ],
      },
      // ItemList Schema
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: ARTICLES.map((article, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            url: `${SITE_URL}/blog/${article.slug}`,
            author: {
              '@type': 'Organization',
              name: 'Hoosier Life Insurance',
              url: SITE_URL
            },
            publisher: {
              '@type': 'Organization',
              name: 'Hoosier Life Insurance',
              url: SITE_URL,
            },
            datePublished: new Date(article.date).toISOString(),
          },
        })),
      },
    ];

    schemas.forEach((schema, idx) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-blog-index-${idx}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Cleanup function
    return () => {
      schemas.forEach((_, idx) => {
        const script = document.getElementById(`schema-blog-index-${idx}`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);

  const filtered = ARTICLES.filter(a => {
    const matchCat = activeCategory === 'All' || a.category === activeCategory;
    const q = searchQuery.toLowerCase();
    const matchSearch = !q || a.title.toLowerCase().includes(q) || a.excerpt.toLowerCase().includes(q) || a.category.toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  const featured = ARTICLES[0];

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Header />

      {/* Hero Banner */}
      <section className="bg-[#1A3A52] pt-28 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#D97642] blur-3xl translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-white blur-3xl -translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="max-w-6xl mx-auto px-6 relative">
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm mb-6">
            <Link to="/" className="text-white/60 hover:text-[#D97642] transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line text-white/30"></i>
            <span className="text-[#D97642] font-medium">Blog</span>
          </nav>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 bg-[#D97642]/20 text-[#D97642] text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
              <i className="ri-article-line"></i>
              27 Expert Articles
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
              Life Insurance Guides for Indianapolis Families
            </h1>
            <p className="text-white/70 text-lg leading-relaxed">
              In-depth guides on term life, whole life, annuities, final expense, and wealth-building strategies — written by a licensed Indiana agent.
            </p>
            <div className="mt-4">
              <Link
                to="/learning-hub"
                className="inline-flex items-center gap-2 text-[#D97642] hover:text-white transition-colors text-sm font-semibold"
              >
                <i className="ri-map-2-line"></i>
                Browse all 27 guides by topic cluster &rarr;
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Search + Filter Bar */}
      <section className="bg-white border-b border-gray-100 sticky top-20 z-30 shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          {/* Search */}
          <div className="relative w-full sm:w-72">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            <input
              type="text"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#D97642]/30 focus:border-[#D97642] bg-gray-50"
            />
          </div>
          {/* Category Pills */}
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-[#1A3A52] text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      <main className="max-w-6xl mx-auto px-6 py-12">

        {/* Featured Article */}
        {activeCategory === 'All' && !searchQuery && (
          <section className="mb-14">
            <div className="flex items-center gap-2 mb-5">
              <i className="ri-bookmark-fill text-[#D97642]"></i>
              <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Featured Article</span>
            </div>
            <Link
              to={`/blog/${featured.slug}`}
              className="group grid md:grid-cols-2 gap-0 bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="relative overflow-hidden h-64 md:h-auto">
                <img
                  src={featured.image}
                  alt={featured.title}
                  title={featured.title}
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                  width={600}
                  height={400}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <span className={`absolute top-4 left-4 text-xs font-bold px-3 py-1.5 rounded-full ${CATEGORY_COLORS[featured.category]}`}>
                  {featured.category}
                </span>
              </div>
              <div className="p-8 md:p-10 flex flex-col justify-center">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-[#D97642]"></i>
                    {featured.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-[#D97642]"></i>
                    {featured.readTime}
                  </span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 leading-tight group-hover:text-[#D97642] transition-colors">
                  {featured.title}
                </h2>
                <p className="text-gray-600 leading-relaxed mb-6 text-sm">
                  {featured.excerpt}
                </p>
                <span className="inline-flex items-center gap-2 text-[#D97642] font-semibold text-sm group-hover:gap-3 transition-all">
                  Read Full Guide <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          </section>
        )}

        {/* Results Count */}
        <div className="flex items-center justify-between mb-6">
          <p className="text-sm text-gray-500">
            Showing <strong className="text-gray-800">{filtered.length}</strong> article{filtered.length !== 1 ? 's' : ''}
            {activeCategory !== 'All' && <> in <strong className="text-[#D97642]">{activeCategory}</strong></>}
            {searchQuery && <> matching <strong className="text-[#D97642]">&ldquo;{searchQuery}&rdquo;</strong></>}
          </p>
          {(activeCategory !== 'All' || searchQuery) && (
            <button
              onClick={() => { setActiveCategory('All'); setSearchQuery(''); }}
              className="text-xs text-gray-400 hover:text-[#D97642] transition-colors flex items-center gap-1 cursor-pointer"
            >
              <i className="ri-close-line"></i> Clear filters
            </button>
          )}
        </div>

        {/* Article Grid */}
        {filtered.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map(article => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 flex flex-col"
              >
                {/* Thumbnail */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    loading="lazy"
                    decoding="async"
                    width={600}
                    height={400}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  <span className={`absolute top-3 left-3 text-xs font-bold px-2.5 py-1 rounded-full ${CATEGORY_COLORS[article.category] || 'bg-gray-100 text-gray-600'}`}>
                    {article.category}
                  </span>
                </div>

                {/* Content */}
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug group-hover:text-[#D97642] transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed flex-1 line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-xs text-gray-400">
                      <div className="w-6 h-6 flex items-center justify-center bg-[#1A3A52] rounded-full">
                        <i className="ri-user-line text-white text-xs"></i>
                      </div>
                      Benjamin Wright
                    </div>
                    <span className="text-xs font-semibold text-[#D97642] flex items-center gap-1 group-hover:gap-2 transition-all">
                      Read <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-4">
              <i className="ri-search-line text-2xl text-gray-400"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-700 mb-2">No articles found</h3>
            <p className="text-gray-500 text-sm mb-4">Try a different search term or category.</p>
            <button
              onClick={() => { setActiveCategory('All'); setSearchQuery(''); }}
              className="px-5 py-2.5 bg-[#D97642] text-white rounded-lg text-sm font-semibold hover:bg-[#C26638] transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Articles
            </button>
          </div>
        )}

        {/* Bottom CTA */}
        <section className="mt-16 bg-gradient-to-br from-[#1A3A52] to-[#0F2A3F] rounded-2xl p-10 text-center text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#D97642]/10 blur-3xl translate-x-1/2 -translate-y-1/2"></div>
          <div className="relative">
            <div className="w-14 h-14 flex items-center justify-center bg-[#D97642]/20 rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-[#D97642]"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-3">Ready to Protect Your Family?</h2>
            <p className="text-white/70 mb-7 max-w-xl mx-auto">
              Get a free, no-obligation quote in under 5 minutes. A licensed Indianapolis agent will help you find the right coverage at the best price.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/instant-quote"
                className="px-7 py-3.5 bg-[#D97642] text-white rounded-lg font-bold hover:bg-[#C26638] transition-colors whitespace-nowrap"
              >
                Get Instant Quote
              </Link>
              <Link
                to="/book-appointment"
                className="px-7 py-3.5 bg-white/10 text-white rounded-lg font-bold hover:bg-white/20 transition-colors border border-white/20 whitespace-nowrap"
              >
                Talk to an Agent
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
